













import { FiltroEnviosAutomaticos } from '@/services/consultores.service';
import SelectPeriodo from '@/shared/components/select-periodo.vue';
import dayjs from 'dayjs';
import Vue from 'vue';
import Component from "vue-class-component";
import { Emit, Prop } from 'vue-property-decorator';


@Component({
    components: {
        SelectPeriodo
    }
})
export default class FiltrosEnvioAutomaticoForm extends Vue {
    @Prop({ required: true }) idConsultor!: number;

    filtros: FiltroEnviosAutomaticos = {
        idConsultor: this.idConsultor, // este campo será preenchido no onMounted
        // adicione outros campos conforme a interface, exceto idConsultor
    };

    onMounted() {
        this.filtros = {
            ...this.filtros,
            idConsultor: this.idConsultor,
        };
    }

    @Emit('Pesquisar')
    onSubmit(): FiltroEnviosAutomaticos | undefined {
        console.log('Pesquisou');
        const form = this.$refs.form as any;

        if (form.validate()) {
            this.filtros.formattedValueInicio = '';
            this.filtros.formattedValueFim = '';
            if (this.filtros.periodo) {
                if (this.filtros.periodo.dataInicio) {
                    const objDataInicio = dayjs(this.filtros.periodo.dataInicio!);
                    this.filtros.formattedValueInicio = objDataInicio.format("DD/MM/YYYY");
                }

                if (this.filtros.periodo.dataFim) {
                    const objDataFim = dayjs(this.filtros.periodo.dataFim!);
                    this.filtros.formattedValueFim = objDataFim.format("DD/MM/YYYY");
                }

                const datas = [];
                if (this.filtros.formattedValueInicio) {
                    datas.push(this.filtros.formattedValueInicio);
                }

                if (this.filtros.formattedValueFim) {
                    datas.push(this.filtros.formattedValueFim);
                }

                this.filtros.txtPesquisa = datas.join(' - ');
            }

            console.log("Filtros enviados:", this.filtros);

            return {
                ...this.filtros,
                offset: 0,
                limit: 10,
            };
        }
    }
}
